import { Injectable } from '@angular/core';
import { NotificationType } from '@shared/elements/notification/notification';
import { Notification } from '@shared/elements/notification/notification';
import { Subject, Observable } from 'rxjs';
import { ModalClosed } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private _subject = new Subject<Notification | ModalClosed>();
  private _idx = 0;

  constructor() {}

  getObservable(): Observable<Notification | ModalClosed> {
    return this._subject.asObservable();
  }

  info(title: string | number, message: string, timeout = 3000) {
    this._subject.next(new Notification(this._idx++, NotificationType.info, title, message, timeout));
  }

  success(title: string | number, message: string, timeout = 3000) {
    this._subject.next(new Notification(this._idx++, NotificationType.success, title, message, timeout));
  }

  warning(title: string | number, message: string, timeout = 3000) {
    this._subject.next(new Notification(this._idx++, NotificationType.warning, title, message, timeout));
  }

  error(title: string | number, message: string, timeout = 12000) {
    this._subject.next(new Notification(this._idx++, NotificationType.error, title, message, timeout));
  }

  consent(title: string | number, message: string, timeout = 40000) {
    this._subject.next(new Notification(this._idx++, NotificationType.consent, title, message, timeout));
    return this._idx - 1;
  }

  tokenExpiration(title: string | number, message: string, timeout = 60000) {
    this._subject.next(new Notification(this._idx++, NotificationType.token, title, message, timeout));
    return this._idx - 1;
  }

  close(idx: number, action?: string, data?: any): void {
    this._subject.next({ status: 'close', index: idx, postAction: action, data: data });
  }
}
